<template>
	<div class="sf-input-group-wrapper">
		<!--처리결과-->
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000978') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<!--전체-->
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(item, index) in prcsRsltList" :label="item.commCdName" :value="item.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'prcRsltCd', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.data = this.searchParams.prcRsltCd;
		}
	},
	created() {
		if (this.searchParams.prcRsltCd == null || this.searchParams.prcRsltCd == '') this.searchParams.prcRsltCd = '';
		this.data = this.searchParams.prcRsltCd;
	}
};
</script>

<style></style>
